import useQualificationStructureService from './services/qualificationStructureService';
import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import TargetRuleLayout from './TargetRuleLayout';
import { useMessageService, ErrorMessage } from 'framework/ui/Message';
import { Loading } from 'framework/ui/mui-builder';
import { TargetRule } from './types';
import { usePositionService, PositionType } from 'domain/shared/employee';
import { useTechnologyService, type Technology } from 'domain/shared/career';

interface QualificationStructure {
  structure: TargetRule[];
}

const TargetRulePage = () => {
  const { id } = useParams();
  const { getById } = useQualificationStructureService();
  const { addMessage } = useMessageService();

  const [data, setData] = useState<QualificationStructure | null>(null);
  const [positions, setSpecializations] = useState<PositionType[]>([]);
  const [technologies, setTechnologies] = useState<Technology[]>([]);
  const { findAll: findAllPositions } = usePositionService();
  const { findAll: findAllTechnologies } = useTechnologyService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [positionsData, technologiesData, rulesData] = await Promise.all([
          findAllPositions(),
          findAllTechnologies(),
          // @ts-ignore
          getById(id),
        ]);

        setSpecializations(positionsData as PositionType[]);
        setTechnologies(technologiesData as Technology[]);
        setData(rulesData);
      } catch (err) {
        addMessage(new ErrorMessage('Failed to load specializations and technologies. Please try again later.'));

        setSpecializations([]);
        setTechnologies([]);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <TargetRuleLayout rules={data.structure} positions={positions} technologies={technologies} />
    </>
  );
};
export default TargetRulePage;
